import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PopUpComponent, PopUpService } from './pop-up.service';

@NgModule({
    imports: [CommonModule],
    declarations: [PopUpComponent],
    providers: [PopUpService],
})
export class ExperimentalPopUpModule {}
